import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/explore/components/ExplorePOI/ExplorePOI.tsx");
